import React, { useState } from "react";
import { useInventoryLogic } from "../../verve-inventory/hooks/useInventoryLogic";
import { ItemsMasterView } from "../../verve-inventory/components/ItemsMasterView";
import { InventoryFormModal } from "../../verve-inventory/components/InventoryFormModal";
import { RestockModal } from "../../verve-inventory/components/RestockModal";
import { ItemDetailsModal } from "../../verve-inventory/components/ItemDetailsContent";
import { INVENTORY_SUB_TABS } from "../../../constants/globalConstants";
import { StockTable } from "../../verve-inventory/components/Stock/StockTable";
import { FileText } from "lucide-react";

export const CatlogScreen = () => {
  const {
    search,
    setSearch,
    filters,
    setFilters,
    filtered,
    setRestockItem,
    handleEdit,
    handleViewPurchases,
    deleteItem,
    distributedMap,
    purchasedMap,
    dynamicSettings,
    addOpen,
    setAddOpen,
    form,
    setForm,
    editingItem,
    addItemToList,
    removeItemFromList,
    editItemInList,
    addItem,
    submitting,
    restockItem,
    restockQty,
    setRestockQty,
    restock,
    viewItem,
    setViewItem,
    totalValue,
    itemCount,
    totalUnits,
  } = useInventoryLogic();

  const [activeTab, setActiveTab] = useState("catalog");

  return (
    <div className="flex flex-col gap-6 w-full max-w-full pb-2 overflow-x-hidden p-4">
      {/* Brand Hero Banner */}
      <div className="relative overflow-hidden w-full h-32 bg-white border border-slate-200 rounded-xl flex items-center justify-between">
        {/* Left Text */}
        <div className="pl-8 z-20">
          <h1 className="font-serif font-medium text-3xl text-slate-900 tracking-wide">Verve Catalog</h1>
          <p className="text-sm font-body text-slate-400 mt-2 font-medium">Verve Kitchens Catalog Management</p>
        </div>

        {/* Right Kitchen Image with gradient fade */}
        <div className="w-[50%] h-full relative overflow-hidden flex-shrink-0">
          <div className="absolute inset-0 bg-gradient-to-r from-white via-white/70 to-transparent z-10 w-48" />
          <img
            src="/kitchens/3.jpg"
            alt="Catalog"
            className="absolute top-0 right-0 w-full h-full object-cover object-center"
          />
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col gap-2">
          <span className="text-sm font-medium text-slate-500">Total Items</span>
          <span className="text-2xl font-semibold text-slate-800">{itemCount || 0}</span>
        </div>
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col gap-2">
          <span className="text-sm font-medium text-slate-500">Total Units</span>
          <span className="text-2xl font-semibold text-slate-800">{totalUnits || 0}</span>
        </div>
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col gap-2">
          <span className="text-sm font-medium text-slate-500">Total Value</span>
          <span className="text-2xl font-semibold text-slate-800">₹{totalValue?.toLocaleString('en-IN') || 0}</span>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col flex-1">
        {/* Action Bar (Matches Contacts Page Style) */}
        <div className="flex flex-col md:flex-row items-center justify-between border-b border-slate-200 px-1 gap-4 bg-white">
          <div className="flex items-center overflow-x-auto no-scrollbar">
            <button
              onClick={() => setActiveTab("files")}
              className={`flex items-center gap-2 px-6 py-3 text-[13px] font-medium transition-all relative whitespace-nowrap ${activeTab === "files" ? "text-brand-blue border-b-2 border-brand-blue bg-blue-50/30" : "text-slate-500 hover:text-slate-700 hover:bg-slate-50"}`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
              Files History
            </button>
            <button
              onClick={() => setActiveTab("blum_catalog")}
              className={`flex items-center gap-2 px-6 py-3 text-[13px] font-medium transition-all relative whitespace-nowrap ${activeTab === "blum_catalog" ? "text-brand-blue border-b-2 border-brand-blue bg-blue-50/30" : "text-slate-500 hover:text-slate-700 hover:bg-slate-50"}`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
              Blum Catalog
            </button>
            <button
              onClick={() => setActiveTab("carcase_catalog")}
              className={`flex items-center gap-2 px-6 py-3 text-[13px] font-medium transition-all relative whitespace-nowrap ${activeTab === "carcase_catalog" ? "text-brand-blue border-b-2 border-brand-blue bg-blue-50/30" : "text-slate-500 hover:text-slate-700 hover:bg-slate-50"}`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
              Carcase Catalog
            </button>
            <button 
              onClick={() => setActiveTab("europlak_catalog")}
              className={`flex items-center gap-2 px-6 py-3 text-[13px] font-medium transition-all relative whitespace-nowrap ${activeTab === "europlak_catalog" ? "text-brand-blue border-b-2 border-brand-blue bg-blue-50/30" : "text-slate-500 hover:text-slate-700 hover:bg-slate-50"}`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
              Europlak Catalog
            </button>
          </div>

          <div className="flex flex-wrap items-center gap-2 pb-4 md:pb-0 w-full md:w-auto justify-center md:justify-end md:ml-auto pr-4">
            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-[13px] font-medium transition-colors border border-slate-200 bg-white shadow-sm hover:bg-slate-100 px-4 py-2 min-w-[140px]">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
              Download
            </button>
            <label className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-[13px] font-medium transition-colors border border-slate-200 bg-white shadow-sm hover:bg-slate-100 px-4 py-2 min-w-[140px] cursor-pointer">
              <input type="file" className="hidden" accept=".csv, .xlsx, .xls" />
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
              Upload
            </label>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="flex-1 overflow-auto bg-slate-50 p-4">
          {activeTab === "files" ? (
            <div className="flex flex-col items-center justify-center h-64 text-center">
              <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mb-4 text-slate-400">
                <FileText size={32} />
              </div>
              <h3 className="text-lg font-medium text-slate-800">No Upload History</h3>
              <p className="text-sm text-slate-500 max-w-md mt-1">You haven't uploaded any catalog files yet. Bulk imports will appear here.</p>
            </div>
          ) : (
            <div className="space-y-6">
              <StockTable
                purchases={filtered}
                dynamicSettings={dynamicSettings}
                onEdit={handleEdit}
                onView={setViewItem}
              />
            </div>
          )}
        </div>
      </div>

      {/* Modals */}
      {addOpen && (
        <InventoryFormModal
          isOpen={addOpen}
          onClose={() => setAddOpen(false)}
          form={form}
          setForm={setForm}
          editingItem={editingItem}
          dynamicSettings={dynamicSettings}
          addItemToList={addItemToList}
          removeItemFromList={removeItemFromList}
          editItemInList={editItemInList}
          onSave={addItem}
          isSubmitting={submitting}
        />
      )}

      {restockItem && (
        <RestockModal
          isOpen={!!restockItem}
          onClose={() => setRestockItem(null)}
          item={restockItem}
          qty={restockQty}
          setQty={setRestockQty}
          onSave={restock}
          isSubmitting={submitting}
        />
      )}

      {viewItem && (
        <ItemDetailsModal
          isOpen={!!viewItem}
          onClose={() => setViewItem(null)}
          item={viewItem}
        />
      )}
    </div>
  );
};
